import { render } from "./Planned.vue?vue&type=template&id=10ce6534"
import script from "./Planned.vue?vue&type=script&lang=js"
export * from "./Planned.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Cards/Settings/Planned.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "10ce6534"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('10ce6534', __exports__)) {
    api.reload('10ce6534', __exports__)
  }
  
  module.hot.accept("./Planned.vue?vue&type=template&id=10ce6534", () => {
    api.rerender('10ce6534', render)
  })

}


export default __exports__